/*@ngInject*/
const LoadWidgetLayoutTemplateRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadWidgetLayoutTemplate = function () {
        let url = '/rest/WidgetLayoutTemplate';

        return this.get(url);
    };
};

angular.module('umLanding')
    .service('loadWidgetLayoutTemplateRepository', LoadWidgetLayoutTemplateRepository);
